import type { MutableRefObject } from 'react';
import { useEffect, useMemo, useRef, useState } from 'react';

const useIntersect = (threshold = 0.2): [boolean, MutableRefObject<any>] => {
  const ref = useRef<HTMLElement | null>(null);
  const [intersect, setIntersect] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver(
        ([entry]) => setIntersect(entry.isIntersecting),
        { threshold },
      ),
    [threshold],
  );

  useEffect(() => {
    if (!ref.current) return;

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [observer]);

  return [intersect, ref];
};

export default useIntersect;
